var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgRightCaret = function SvgRightCaret(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M.25 17.75a.731.731 0 0 1-.225-.536c0-.208.075-.387.225-.537l7.7-7.69L.225 1.274A.718.718 0 0 1 0 .75c0-.2.083-.375.25-.524C.4.075.58 0 .788 0c.208 0 .387.075.537.225l8.2 8.188c.083.1.142.196.175.287a.837.837 0 0 1 0 .574.982.982 0 0 1-.175.288L1.3 17.775A.706.706 0 0 1 .788 18c-.192 0-.371-.083-.538-.25Z"
  })));
};
export default SvgRightCaret;